<div class="row">
  <div class="col-12">
    <dynamic-validation *ngIf="subTab=='dynamic'"
            [serviceId]="serviceId"
            [componentValidationId]="componentValidationId"
            [componentKey]="componentKey">
    </dynamic-validation>
    <validation-blacklist *ngIf="subTab=='blacklist'"
            [serviceId]="serviceId"
            [componentValidationId]="componentValidationId"
            [componentKey]="componentKey">
    </validation-blacklist>
  </div>
</div>
